import { useEffect, useState } from "react";
import { api, ROLE_LABELS } from "@/lib/api";
import { BellRing, Send } from "lucide-react";
import { toast } from "sonner";

const SECTIONS = ["tutti", "soci", "consiglio", "fondatori", "collaboratori", "tesoriere", "segretario", "tesseramento", "donatore"];

export default function PushBroadcast() {
  const [title, setTitle] = useState("");
  const [body, setBody] = useState("");
  const [section, setSection] = useState("tutti");
  const [stats, setStats] = useState(null);
  const [busy, setBusy] = useState(false);

  const loadStats = () => api.get("/admin/push/stats").then((r) => setStats(r.data)).catch(() => {});
  useEffect(() => { loadStats(); }, []);

  const send = async () => {
    if (!title.trim() || !body.trim()) { toast.error("Titolo e messaggio obbligatori"); return; }
    setBusy(true);
    try {
      const { data } = await api.post("/admin/push/broadcast", { title, body, section });
      toast.success(`Notifica inviata a ${data.sent} dispositivi`);
      setTitle(""); setBody("");
      loadStats();
    } catch (e) {
      toast.error(e.response?.data?.detail || "Errore invio notifica");
    } finally { setBusy(false); }
  };

  return (
    <div className="paper rounded-2xl p-6" data-testid="push-broadcast-card">
      <div className="flex items-center justify-between mb-4">
        <div className="font-display text-xl font-bold text-[#2B3A33] flex items-center gap-2"><BellRing className="w-5 h-5 text-[#EF3E36]" /> Notifica push nell'app</div>
        {stats && <span className="text-xs text-[#8A8272]" data-testid="push-subscribed-count">{stats.subscribed_users} soci con notifiche attive</span>}
      </div>
      <p className="text-sm text-[#6B6558] mb-4">Arriva direttamente sul telefono di chi ha attivato le notifiche, anche con l'app chiusa.</p>
      <div className="grid gap-3">
        <select data-testid="push-section-select" value={section} onChange={(e) => setSection(e.target.value)} className="w-full px-3 py-2 rounded-lg border border-[#E8E2D8] bg-white text-sm">
          {SECTIONS.map((s) => <option key={s} value={s}>{s === "tutti" ? "Tutti i soci" : ROLE_LABELS[s] || s}</option>)}
        </select>
        <input data-testid="push-title-input" value={title} onChange={(e) => setTitle(e.target.value)} maxLength={60} placeholder="Titolo (es. Riunione straordinaria)" className="w-full px-3 py-2 rounded-lg border border-[#E8E2D8] bg-white text-sm" />
        <textarea data-testid="push-body-input" value={body} onChange={(e) => setBody(e.target.value)} maxLength={180} rows={3} placeholder="Messaggio breve…" className="w-full px-3 py-2 rounded-lg border border-[#E8E2D8] bg-white text-sm" />
        <button data-testid="push-send-btn" onClick={send} disabled={busy} className="terracotta-btn px-4 py-2.5 rounded-lg text-sm font-semibold flex items-center justify-center gap-2 disabled:opacity-60">
          <Send className="w-4 h-4" /> {busy ? "Invio…" : "Invia notifica"}
        </button>
      </div>
      {stats?.last?.length > 0 && (
        <div className="mt-4 border-t border-[#E8E2D8] pt-3 space-y-1">
          <div className="text-xs uppercase tracking-widest text-[#8A8272] font-semibold">Ultime inviate</div>
          {stats.last.filter((l) => l.title).slice(0, 5).map((l, i) => (
            <div key={l.created_at || l.at || `${l.title}-${l.sent}-${i}`} className="text-xs text-[#6B6558] flex justify-between gap-2"><span className="truncate">{l.title}</span><span className="shrink-0">{l.sent} inviate</span></div>
          ))}
        </div>
      )}
    </div>
  );
}
